import api from "../services/api";

const path = "promotor";

export const getPromoters = async ({ params = "" }) => {
  return await api.get(`${path}${params}`);
};
